// @flow

export const GLOBAL_MESSAGE_ERROR = 'global.message.error';

export const GLOBAL_MESSAGE_SUCCESS = 'global.message.success';

export const GLOBAL_MESSAGE_REMOVE = 'global.message.remove';
